import React from 'react';

import Card from '../../card/card';
import ListWrapper from './list-wrapper';
import ConfirmationModal from '../../confirmation-modal/confirmation-modal';
import ContentTypes from '../../../utils/content-types';

export default class CardList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            item: null,
        };
    }

    updateNestedItem = (key, value) => {
        const { card, name } = this.props;
        this.props.updateNestedItem(name, { ...card, [key]: value });
    };

    updateNestedArray = (index, value) => {
        const cards = [...this.props.card.cards];
        value !== undefined ? cards[index] = value : cards.splice(index, 1);
        this.updateNestedItem('cards', cards);
    };

    addNewItem = () => {
        this.updateNestedArray(this.props.card.cards.length, ContentTypes.CARDS.build());
    };

    render() {
        const { card, match, links } = this.props;
        const { cards = [] } = card;
        return (
            <ListWrapper
                {...card} links={links}
                updateNestedItem={this.updateNestedItem}
                addNewItem={this.addNewItem}
                trainers={this.props.trainers}
                centers={this.props.centers}
            >
                <div className='class-resources-wrapper'>
                    {cards
                        .map((card, i) => (
                            <Card
                                card={card}
                                key={card.id}
                                url={match.url}
                                onDelete={() => this.setState({ modal: true, item: i })}
                            />
                        ))}
                </div>
                {
                    this.state.item !== null &&
                    <ConfirmationModal
                        show={this.state.modal}
                        onClose={() => this.setState({ modal: false, item: null })}
                        onConfirm={() => this.updateNestedArray(this.state.item, undefined)}
                    />
                }
            </ListWrapper>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/section/components/card-list.js